import Layout from '../views/layout/App.vue'

export default {
    path: '/courseTypeManage',
    name: 'CourseTypeManage',
    meta: {
        title: '课程分类管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/courseTypeManage',
    children: [{
            path: 'firstCourseList',
            name: 'firstCourseList',
            meta: {
                title: '一级课程分类列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/courseTypeManage/firstCourseList/Index.vue'], resolve),
        },
        {
            path: 'secondCourseList',
            name: 'secondCourseList',
            meta: {
                title: '二级课程分类列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/courseTypeManage/secondCourseList/Index.vue'], resolve),
        },
        {
            path: 'threeCourseList',
            name: 'threeCourseList',
            meta: {
                title: '三级课程分类列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/courseTypeManage/threeCourseList/Index.vue'], resolve),
        },
    ]
}